import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { PageNotFoundPageRoutingModule } from "./page-not-found-routing.module";

import { PageNotFoundPage } from "./page-not-found.page";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "../_component/header/header.module";
import { ApiNotFoundComponentModule } from "../app/_component/api-not-found/api-not-found.component.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PageNotFoundPageRoutingModule,
    TranslateModule,
    HeaderModule,
    ApiNotFoundComponentModule,
  ],
  declarations: [PageNotFoundPage],
})
export class PageNotFoundPageModule {}
